// extracted by mini-css-extract-plugin
export default {"inputbox":"DatePicker_inputbox__3jINT"};